import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

export default class NavbarDropdownItem extends Component {

  render() {

    if (this.props.item.onClick) {
      return (
        <div className={`navbar-dropdown-item ${this.props.item.className || ''}`} onClick={this.props.onClick}>
          {this.props.item.title}
        </div>
      );
    }
    return (
      <Link className={`navbar-dropdown-item ${this.props.item.className || ''}`} to={this.props.item.route} onClick={this.props.onClick}>
        {this.props.item.title}
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarDropdown/NavbarDropdownItem/index.js